/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'ai-mate.agent-header-banner-label': '에이전트 배너',
  'ai-mate.agent-list.all-agents-section-title': '모든 에이전트',
  'ai-mate.agent-list.beta-lozenge-title': '베타',
  'ai-mate.agent-list.change-owner-success-flag-description': '{agentName}의 소유자를 {newOwnerName}(으)로 변경함',
  'ai-mate.agent-list.change-owner-success-flag-title': '소유자가 변경되었습니다',
  'ai-mate.agent-list.delete-agent-confirm-body': '이 에이전트를 삭제하시겠습니까? 이 작업은 실행 취소할 수 없습니다.',
  'ai-mate.agent-list.delete-agent-confirm-title': '"{agentName}"을(를) 삭제하시겠습니까?',
  'ai-mate.agent-list.delete-agent-error': '에이전트를 삭제할 수 없음',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    '에이전트를 삭제하는 동안 문제가 발생했습니다. 잠시 후에 다시 시도하세요.',
  'ai-mate.agent-list.delete-agent-error-flag-title': '에이전트를 삭제하지 못함',
  'ai-mate.agent-list.delete-agent-error.agent-in-use': '에이전트가 현재 사용 중입니다. 나중에 다시 시도하세요.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': '에이전트를 찾을 수 없습니다.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    '직접 만들지 않은 에이전트는 삭제할 수 없습니다. 에이전트 소유자에게 문의하세요.',
  'ai-mate.agent-list.delete-agent-success-flag-description': '{agentName} 님을 삭제했습니다',
  'ai-mate.agent-list.delete-agent-success-flag-title': '에이전트 삭제됨',
  'ai-mate.agent-list.development-section-title': '개발 에이전트',
  'ai-mate.agent-list.load-more-button-loading': '더 많은 에이전트 로드 중...',
  'ai-mate.agent-list.load-more-button-ready': '더 로드하기',
  'ai-mate.agent-list.loading-agents': '에이전트 로드 중...',
  'ai-mate.agent-list.no-results': '"{searchValue}"에 대한 결과가 없습니다',
  'ai-mate.agent-list.recommended-agents-section-title': '추천',
  'ai-mate.agent-list.searching-agents': '에이전트 검색 중...',
  'ai-mate.agent-list.templates-description':
    '이 템플릿을 사용하여 자신만의 개발 에이전트를 만드세요. 업무에 적합한 에이전트 템플릿을 선택하고 템플릿 사용을 선택한 다음 템플릿 프롬프트에 리포지토리, 폴더, 언어 및 라이브러리와 같은 특정 세부 정보를 입력합니다. 다양한 작업, 프로젝트 또는 리포지토리를 코딩하는 맞춤형 개발 에이전트를 만드세요.',
  'ai-mate.agent-list.templates-lozenge-title': '템플릿',
  'ai-mate.agent-list.templates-title': '코딩 템플릿',
  'ai-mate.agent-message.agent-not-found': '에이전트를 찾을 수 없음',
  'ai-mate.agent-message.convo-title': '스마트 링크 포함에서 {agentName}과(와)의 채팅이 트리거되었습니다',
  'ai-mate.agent-message.copy-link': '에이전트 링크 복사',
  'ai-mate.agent-message.prompt': '프롬프트',
  'ai-mate.agent-message.prompt-placeholder': '{agentName}에게 메시지 입력',
  'ai-mate.agent-message.prompt-submit': '제출',
  'ai-mate.agent-message.view-profile': '프로필 보기',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': '취소',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': '삭제',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': '에이전트 · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': '{agentName} 님과 채팅',
  'ai-mate.agent-profile-info.copy-agent-link-clicked-tooltip': 'URL 복사함',
  'ai-mate.agent-profile-info.copy-agent-link-tooltip': '링크 복사',
  'ai-mate.agent-profile-info.hidden-icon': '숨김',
  'ai-mate.agent-profile-info.hidden-tooltip': '에이전트는 검색 결과에 표시되지 않습니다',
  'ai-mate.agent-profile-info.star-agent-tooltip': '에이전트 별표 표시',
  'ai-mate.agent-selector.default-agent-description':
    '답변을 받고 새로운 아이디어를 창출하고 일상적인 작업 속도를 높이세요.',
  'ai-mate.agent-selector.default-agent-name': '채팅',
  'ai-mate.browse-agents-view.close-button': '에이전트 보기 닫기',
  'ai-mate.profile-card-preview.actions-title': '작업',
  'ai-mate.profile-card-preview.agent-default-title': '에이전트',
  'ai-mate.profile-card-preview.agent-description-label': '설명',
  'ai-mate.profile-card-preview.agent-title-label': '제목',
  'ai-mate.profile-card-preview.conversation-starters-heading': '대화 시작 프롬프트',
  'ai-mate.profile-card-preview.empty-actions': '없음',
  'ai-mate.profile-card-preview.empty-conversation-starters': '없음',
  'ai-mate.profile-card-preview.empty-instructions': '없음',
  'ai-mate.profile-card-preview.empty-knowledge-scope': '선택한 항목 없음',
  'ai-mate.profile-card-preview.instructions-title': '안내',
  'ai-mate.profile-card-preview.knowledge-title': '참조 자료',
  'ai-mate.profile-card-preview.regenerate-label': '{fieldName} 다시 생성',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} - 복사',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': '끌어서 순서 변경',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': '변경 사항을 저장할 수 없음',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    '알 수 없는 오류가 발생했습니다. 다시 시도하세요',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    '이 이름의 에이전트가 이미 있습니다',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': '제거',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text': '대화 시작 프롬프트 생성',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, other {{fieldName}은(는) {maxLength,number}자를 초과할 수 없습니다}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': '다음',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': '재시작',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': '수동 설정으로 건너뛰기',
  'create-agent.owner-field.confirm-modal-cancel': '취소',
  'create-agent.owner-field.confirm-modal-confirm': '예. 계속하기',
  'create-agent.owner-field.confirm-modal-content':
    '이 에이전트의 소유자를 {name} 님으로 변경하려고 합니다. 그러면 더 이상 이 에이전트를 편집하거나 관리할 수 없게 됩니다.',
  'create-agent.owner-field.confirm-modal-title': '편집 권한을 잃게 됩니다',
  'create-agent.owner-field.owner-description': '에이전트를 편집 또는 관리할 수 있는 사용자입니다.',
  'create-agent.owner-field.owner-label': '소유자',
  'rovo-chat.agent-card.deactivated-name': '{name}(비활성화됨)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': '요청이 너무 많습니다. 잠시 기다려 주세요.',
  'rovo-chat.browse-agents.agents-error-try-again-button': '다시 시도',
  'rovo-chat.browse-agents.all-agents-button': '전체',
  'rovo-chat.browse-agents.close-button': '닫기',
  'rovo-chat.browse-agents.create-agent-button': '만들기',
  'rovo-chat.browse-agents.create-an-agent-button': '에이전트 만들기',
  'rovo-chat.browse-agents.created-by-label': '<text>작성자:</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': '코딩 에이전트',
  'rovo-chat.browse-agents.favorite-agents-button': '즐겨찾기',
  'rovo-chat.browse-agents.favourited-agent-label': '즐겨 사용하는 에이전트',
  'rovo-chat.browse-agents.modal-title': '에이전트 찾아보기',
  'rovo-chat.browse-agents.my-agents-button': '내 에이전트',
  'rovo-chat.browse-agents.no-created-agents':
    '아직 에이전트를 만들지 않은 것 같습니다. 기존의 다른 에이전트들을 복제하여 시작하거나 처음부터 새로 만드세요.',
  'rovo-chat.browse-agents.no-created-agents-header': '아직 만든 에이전트 없음',
  'rovo-chat.browse-agents.no-starred-agents':
    '자주 또는 즐겨 사용하는 에이전트가 있으면 쉽게 액세스할 수 있도록 별표 표시하세요.',
  'rovo-chat.browse-agents.no-starred-agents-header': '별표 표시한 에이전트가 아직 없습니다',
  'rovo-chat.browse-agents.search-input.placeholder': '에이전트 검색',
  'rovo-chat.browse-agents.search-templates-input.placeholder': '템플릿 검색',
  'rovo-chat.browse-agents.see-all-agents-button': '모든 에이전트 보기',
  'rovo-chat.browse-agents.templates-button': '템플릿',
  'rovo-chat.create-agent.actions-section-description':
    'Jira, Confluence 및 Jira Service Management에서 에이전트가 작업을 수행할 수 있도록 작업을 추가하세요. <link>에이전트 작업이란 무엇입니까?</link>',
  'rovo-chat.create-agent.add-actions-button-label': '작업 추가',
  'rovo-chat.create-agent.all-content-label': '모든 콘텐츠',
  'rovo-chat.create-agent.back-button': '뒤로 가기',
  'rovo-chat.create-agent.confirm-leave-modal.body': '에이전트를 아직 만들지 않았습니다. 버리시겠습니까?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': '취소',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': '네, 에이전트를 버립니다',
  'rovo-chat.create-agent.confirm-leave-modal.title': '완료되지 않은 에이전트',
  'rovo-chat.create-agent.confirm-restart-modal.body': '이 에이전트에 대한 변경 사항을 버리시겠습니까?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': '확인',
  'rovo-chat.create-agent.confirm-restart-modal.title': '만들기 다시 시작',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    '사용자가 이것을 사용하여 에이전트와 채팅을 시작할 수 있습니다. 생각나는 것이 없는 경우 대신 생성해 드릴 수 있습니다.',
  'rovo-chat.create-agent.conversation-starters-field-label': '대화 시작 프롬프트',
  'rovo-chat.create-agent.create-agent-button': '만들기',
  'rovo-chat.create-agent.ctions-section-title': '작업',
  'rovo-chat.create-agent.description-field-description':
    '사용자가 에이전트 프로필에 설명을 통해 에이전트에 대해 자세히 알아볼 수 있습니다.',
  'rovo-chat.create-agent.description-field-label': '설명',
  'rovo-chat.create-agent.description-field-placeholder':
    '에이전트에 대한 간단한 설명을 작성하세요(예: 마케팅 블로그 작성을 위한 에이전트)',
  'rovo-chat.create-agent.instructions-field-description':
    '이 에이전트가 어떻게 행동하기를 원하십니까? 어떤 작업을 할 수 있습니까? <link>에이전트용 안내 작성에 대해 자세히 알아보기</link>',
  'rovo-chat.create-agent.instructions-field-label': '안내',
  'rovo-chat.create-agent.instructions-field-placeholder': '이 에이전트에 대한 안내 사용자 지정',
  'rovo-chat.create-agent.intro-description-part-1':
    '질문에 답하고 콘텐츠를 작성 및 검토하고 업무에 도움이 되는 작업을 수행할 수 있는 전문 지식을 갖춘 에이전트를 만드세요.',
  'rovo-chat.create-agent.intro-description-part-2':
    '도움이 필요하지 않은 경우 <bold>수동 설정으로 건너뛸</bold> 수 있습니다.',
  'rovo-chat.create-agent.intro-description-part-3': '도움이 필요하다면 함께 여기에서 만들어 보세요.',
  'rovo-chat.create-agent.intro-step-1-content':
    '작성한 내용을 기반으로 에이전트에 대한 안내를 만듭니다. 에이전트를 어떤 용도로 사용할 계획인지 말씀해 주세요.',
  'rovo-chat.create-agent.intro-step-1-title': '에이전트가 수행할 작업 설명',
  'rovo-chat.create-agent.intro-step-2-content':
    '에이전트의 이름 및 성격을 결정합니다. 에이전트가 공감 능력이 뛰어난지, 직설적인지, 재미있는지 선택하세요.',
  'rovo-chat.create-agent.intro-step-2-title': '성격 부여',
  'rovo-chat.create-agent.intro-step-3-content':
    '새 에이전트를 검토하고 작업, 참조 자료 및 프로필 사진을 추가하려면 <bold>다음</bold>을 누르세요. 다 마치면 <bold>만들기</bold>를 선택합니다.',
  'rovo-chat.create-agent.intro-step-3-title': '에이전트 검토 및 만들기',
  'rovo-chat.create-agent.intro-title': '👋 에이전트 만들어 보기',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': '모든 프로젝트',
  'rovo-chat.create-agent.knowledge-field-description':
    '제공한 출처만 참조하도록 허용하여 에이전트의 지식을 구체적으로 지정하세요',
  'rovo-chat.create-agent.knowledge-field-label': '참조 자료',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': '이 출처만 참고',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': '제안',
  'rovo-chat.create-agent.manage-actions-button-label': '작업 관리',
  'rovo-chat.create-agent.name-field-description': '사용자가 이름을 사용하여 에이전트를 찾을 수 있습니다.',
  'rovo-chat.create-agent.name-field-label': '이름',
  'rovo-chat.create-agent.name-field-placeholder': '에이전트 이름 지정',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error':
    '예상치 못한 오류가 발생했습니다. 다시 시도하세요.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    '안녕하세요! 사용자 지정 에이전트를 만들도록 도와드리겠습니다. 에이전트가 어떤 일을 하도록 할지 알려주세요.',
  'rovo-chat.create-agent.nl-input-field.placeholder': '메시지 입력',
  'rovo-chat.create-agent.nl-input-field.send-button-label': '보내기',
  'rovo-chat.create-agent.page-title': '에이전트 만들기',
  'rovo-chat.create-agent.page-title-edit': '에이전트 편집',
  'rovo-chat.create-agent.search-for-pages-placeholder': '페이지 검색',
  'rovo-chat.create-agent.search-for-spaces-placeholder': '스페이스 검색',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': '전체',
  'rovo-chat.create-agent.select-action-modal-beta-tag': '베타',
  'rovo-chat.create-agent.select-action-modal-cancel-button': '취소',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': '닫기',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, other {{count,number}개 미만의 작업을 선택하면 성능이 최적화됩니다}}',
  'rovo-chat.create-agent.select-action-modal-save-button': '저장',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': '작업 검색',
  'rovo-chat.create-agent.select-action-modal-title': '작업 추가',
  'rovo-chat.create-agent.select-content-under-label': '아래에서 콘텐츠 선택',
  'rovo-chat.create-agent.select-spaces-label': '스페이스 선택',
  'rovo-chat.create-agent.selected-actions-label': '선택한 작업:',
  'rovo-chat.create-agent.unknown-owner': '알 수 없음',
  'rovo-chat.create-agent.update-agent-button': '업데이트',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    '계속하면 저장하지 않은 변경 사항을 잃게 됩니다. 이 에이전트를 계속 편집하려면 취소를 선택하세요.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': '계속하고 변경 사항 버리기',
  'rovo-chat.edit-agent.confirm-discard-modal.title': '변경 사항 버리기',
  'rovo-chat.view-agent.about-label': '정보',
  'rovo-chat.view-agent.actions-label': '작업',
  'rovo-chat.view-agent.beta-label': '베타',
  'rovo-chat.view-agent.beta-tag': '베타',
  'rovo-chat.view-agent.chat-to-agent-button': '에이전트와 채팅',
  'rovo-chat.view-agent.close-button': '닫기',
  'rovo-chat.view-agent.copy-instructions-label': '복사',
  'rovo-chat.view-agent.copy-instructions-tooltip': '지침 복사',
  'rovo-chat.view-agent.created-by-label': '<text>작성자:</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': '즐겨찾기 수',
  'rovo-chat.view-agent.go-back-label': '뒤로 가기',
  'rovo-chat.view-agent.hidden-instructions-description':
    '코드로 만든 Forge 에이전트는 개인 정보 보호를 위해 안내가 숨겨져 있습니다.',
  'rovo-chat.view-agent.hidden-instructions-title': '이 안내는 비공개입니다',
  'rovo-chat.view-agent.hidden-knowledge-description':
    '코드로 구축된 Forge 에이전트는 일반적인 참조 자료 출처를 사용하지 않습니다',
  'rovo-chat.view-agent.instructions-label': '안내',
  'rovo-chat.view-agent.knowledge-label': '참조 자료',
  'rovo-chat.view-agent.member-count': '{count, plural, other {구성원 {count,number}명}}',
  'rovo-chat.view-agent.modal-title': '에이전트 찾아보기',
  'rovo-chat.view-agent.no-actions': '작업 없음',
  'rovo-chat.view-agent.no-instruction-placeholder': '이 에이전트에는 사용자 지정 안내가 없습니다',
  'rovo-chat.view-agent.no-knowledge-added': '사용자 지정 지식 출처 없음',
  'rovo-chat.view-agent.no-teams': '어떤 팀에도 속하지 않음',
  'rovo-chat.view-agent.open-chat-label': '채팅 열기',
  'rovo-chat.view-agent.reactions-metadata-label': '반응 수',
  'rovo-chat.view-agent.rovo-agent-label': 'Rovo 에이전트',
  'rovo-chat.view-agent.teams-label': '팀',
  'rovo-chat.view-agent.users-metadata-label': '사용자 수',
};
